import { render, staticRenderFns } from "./InsureResult.vue?vue&type=template&id=628980a8&"
import script from "./InsureResult.vue?vue&type=script&lang=js&"
export * from "./InsureResult.vue?vue&type=script&lang=js&"
import style0 from "./InsureResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports